import React from 'react';
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {
    SubTaskSingleVoyageTransformForTable,
    TaskSingleVoyageTransformForTable,
    TaskWayPointSingleVoyage
} from "@containers/singleVoyage/tasks/table/types";
import {OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import MutateTaskSingleVoyageModal from "@containers/singleVoyage/tasks/mutateTask/MutateTaskModalSingleVoyage";
import TrCustom from "@ui/tableCustom/view/ui/trCustom/TrCustom";
import {getValueTransformData} from "@helpers/transform/transform";
import ThCustom from "@ui/tableCustom/view/ui/thCustom/ThCustom";
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import {SxType} from "@baseTypes/sx/sxTypes";
import TasksFilesListModalSingleVoyage
    from "@containers/singleVoyage/tasks/tasksFiles/tasksFilesList/TasksFilesListModalSingleVoyage";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const sx: SxType = {
    first: {
        paddingLeft: '40px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    }
}

interface IProps {
    subtasks: SubTaskSingleVoyageTransformForTable[]
    fullColumns: IColumnItem<SubTaskSingleVoyageTransformForTable>[]
    /** Subtasks are edited inside the parent task's form. */
    parent: TaskSingleVoyageTransformForTable
    onSave?: OnSaveTaskSingleVoyage
    voyageId: number
    waypoints: TaskWayPointSingleVoyage[]
    accountId: string | number
}

const TableRowSubTasksSingleVoyage = ({
                                          subtasks,
                                          fullColumns,
                                          parent,
                                          onSave,
                                          voyageId,
                                          waypoints,
                                          accountId,
                                      }: IProps) => {

    return subtasks?.map((subtask) => {
        return (
            <TrCustom
                key={subtask.id}
            >
                {fullColumns?.map((column, index) => {
                    if (index === 0) {
                        return (
                            <ThCustom
                                key={column.id}
                                sx={sx.first}
                            >
                                {subtask?.files?.length >= 1 && <TasksFilesListModalSingleVoyage
                                    files={subtask.files}
                                />}
                                <SubdirectoryArrowRightIcon/>

                                {/* Opens the parent task - a subtask does not
                                    exist on its own. */}
                                {onSave && <MutateTaskSingleVoyageModal
                                    initial={parent}
                                    voyageId={voyageId}
                                    onSave={onSave}
                                    waypoints={waypoints}
                                    accountId={accountId}
                                />}

                                {getValueTransformData(subtask, column.id)}
                            </ThCustom>
                        )
                    }
                    if (column.id === 'waypoints') {
                        return (
                            <ThCustom
                                key={column.id}
                            >
                                <Stack
                                    gap={1}
                                >
                                    {subtask.waypoints?.map((point) => {
                                        return (
                                            <Typography
                                                key={point.id}
                                            >
                                                {point.plannedOrdinal + 1}. {point.name}
                                            </Typography>
                                        )
                                    })}
                                </Stack>
                            </ThCustom>
                        )
                    }
                    return (
                        <ThCustom
                            key={column.id}
                        >
                            {getValueTransformData(subtask, column.id)}
                        </ThCustom>
                    )
                })}
            </TrCustom>
        )
    })


};

export default TableRowSubTasksSingleVoyage;